<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body">
                    <div class="form-group row">
                        <label class="col-sm-2 form-control-label">Tarih Aralığı</label>
                        <div class="col-sm-10">
                            <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" opens="center" :showName="false" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 form-control-label">Servis</label>
                        <div class="col-sm-10">
                            <select2 :data="services"
                                     :selected="filters.service"
                                     :maxSelection="1"
                                     :minSelection="1"
                                     v-on:onChange="onServiceFilterChanged" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 form-control-label">Operatör</label>
                        <div class="col-sm-10">
                            <select2 :data="operators"
                                     :selected="filters.operator_id"
                                     :minSelection="1"
                                     :maxSelection="1"
                                     v-on:onChange="onOperatorFilterChanged" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 form-control-label">Mecra</label>
                        <div class="col-sm-10">
                            <select2 :data="mecra"
                                     :selected="filters.mecra"
                                     v-on:onChange="onMecraFilterChanged" />
                        </div>
                    </div>
                    <div class="form-actions row">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-10">
                            <button type="button" v-on:click="loadData" :disabled="reportDataLoading" class="btn btn-success btn-xs">
                                <span v-if="reportDataLoading == false">Filtrele</span>
                                <span v-if="reportDataLoading">Lütfen bekleyiniz...</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box-header" style="padding-top: 3px; padding-bottom:3px;">&nbsp;</div>
                <div class="box-tool" style="top: 4px;">
                    <ul class="nav">
                        <li class="nav-item inline">
                            <a class="nav-link" v-on:click="downloadCsv"><span class="fa fa-download"></span></a>
                        </li>
                    </ul>
                </div>
                <table2 :rows="data" :headers="tableHeaders" :hasTotalRow="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import parallel from 'async/parallel';
    import Select2 from '../../../components/select.v2.vue';
    import DateRange from '../../../components/daterange.vue';
    import moment from 'moment';
    import $ from 'jquery';
    import Table2 from '../../../components/table.v2.vue';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'daterange': DateRange,
            'table2': Table2
        },
        data: function () {
            return {
                filters: {
                    service: [],
                    mecra: [],
                    operator_id: [],
                    dateRange: [moment(), moment()]
                },
                services: [],
                mecra: [],
                operators: [],
                data: [],
                loading: false,
                reportDataLoading: false,
                csvDownloadUrl: '',
                tableHeaders: [
                    {
                        columnName: 'date',
                        title: 'Tarih',
                        dataFormat: 'date',
                        dateFormat: 'YYYY-MM-DD'
                    },
                    {
                        columnName: 'service',
                        title: 'Servis',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'variant',
                        title: 'Varyant',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'mecra_id',
                        title: 'Mecra',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'start_subs',
                        title: 'Yeni Abone',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'full_paid_start_subs',
                        title: 'Yeni Tam Tahsilatlı Abone',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'end_subs',
                        title: 'Giden Abone',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'total_new_charging',
                        title: 'İlk Gün',
                        dataFormat: 'decimal'
                    },
                    {
                        columnName: 'total_renew_charging',
                        title: 'Yenileme',
                        dataFormat: 'decimal'
                    },
                    {
                        columnName: 'total_charging',
                        title: 'Toplam',
                        dataFormat: 'decimal'
                    }
                ],
            }
        },
        mounted: function () {
            var $this = this;
            this.loading = true;
            parallel([
                function (next) {
                    var params = {
                        dashboard_id: $this.$router.currentRoute.query.id
                    };
                    $this.$app.get('/api/v1/users/' + $this.$app.getUser().id + '/services', params, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.services = $.map(response.services, function (service) {
                            return {
                                id: service.id,
                                text: service.name
                            }
                        });
                        $this.filters.service.push($this.services[0].id);
                        next();
                    });
                },
                function (next) {
                    $this.$app.get('/api/v1/users/' + $this.$app.getUser().id + '/operators', function(xhr) {
                        var response = xhr.responseJSON;
                        $this.operators = $.map(response.operators, function (operator) {
                            return {
                                id: operator.id,
                                text: operator.name
                            }
                        });
                        $this.filters.operator_id.push($this.operators[0].id);
                        next();
                    });
                },
                function (next) {
                    var params = {id: $this.$router.currentRoute.query.id};
                    $this.$app.get('/api/v1/dashboards/report/subscharging/mecra', params, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.mecra = $.map(response.mecra, function (mecra) {
                            return {
                                id: mecra.id,
                                text: mecra.name
                            }
                        });
                        next();
                    });
                }
            ], function (err, results) {
                $this.loading = false;
            });
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    service_id: this.filters.service,
                    mecra_id: this.filters.mecra,
                    operator_id: this.filters.operator_id,
                    start_date: this.filters.dateRange[0].format('YYYY-MM-DD 00:00:00'),
                    end_date: this.filters.dateRange[1].format('YYYY-MM-DD 23:59:59')
                };
                this.$app.get('/api/v1/dashboards/report/subscharging/sum-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                    params.access_token = $this.$app.getAccessToken();
                    params.csv = 1;
                    $this.csvDownloadUrl = '/api/v1/dashboards/report/subscharging/sum-data?' + $.param(params);
                }, {'Timezone': this.$app.getTimezone()});
            },
            formatDate: function (date) {
                // TODO: dateRange değiştiğinde, sonuçlar değişmese bile formatlama yapılıyor!
                if (this.filters.dateRange[0].format('YYYY-MM-DD') === this.filters.dateRange[1].format('YYYY-MM-DD')) {
                    return moment(date, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY HH:mm');
                } else {
                    return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
                }
            },
            downloadCsv: function () {
                if (this.csvDownloadUrl !== '') {
                    window.open(this.csvDownloadUrl);
                }
            },
            onServiceFilterChanged: function (data) {
                this.filters.service = data;
            },
            onOperatorFilterChanged: function (data) {
                this.filters.operator_id = data;
            },
            onMecraFilterChanged: function (data) {
                this.filters.mecra = data;
            },
            onDateFilterChanged: function (data) {
                this.filters.dateRange = data;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// sum.vue?c05cdfd4